import React from "react";
import { Link } from "react-router-dom";
import Isotipo from "./Isotipo";
import { useLang } from "@/context/LanguageContext";

// Crisp vector lockup: GR + official triangular isotype (the "A") + BARTE.
const Logo = ({ className = "", onClick, fill = "#ffffff" }) => {
  const { lp } = useLang();
  return (
    <Link
      to={lp("/")}
      onClick={onClick}
      data-testid="logo-home-link"
      className={`group inline-flex items-center select-none ${className}`}
      aria-label="Grabarte"
    >
      <span
        className="font-display font-black uppercase leading-none"
        style={{ color: fill, fontSize: "1.5rem", letterSpacing: "-0.01em" }}
      >
        GR
      </span>
      <Isotipo
        className="mx-[1px] w-auto"
        style={{ height: "1.12rem", transform: "translateY(1px)" }}
        fill={fill}
      />
      <span
        className="font-display font-black uppercase leading-none"
        style={{ color: fill, fontSize: "1.5rem", letterSpacing: "-0.01em" }}
      >
        BARTE
      </span>
    </Link>
  );
};

export default Logo;
